import { render } from "./Step3.vue?vue&type=template&id=1105252e"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
script.render = render

export default script